import { ProjectFormData, Participant, ProjectStatus, ProblemStatementParts } from '../types/project-form';

export const initialProblemStatementParts: ProblemStatementParts = {
  context: '',
  issue: '',
  denominator: '',
  numerator: '',
  gap: '',
  rootCause: '',
  implication: ''
};

// Initial values for form components
export const initialCHSTeamMember = {
  fullName: '',
  phoneNumber: '',
  role: '',
  customRole: ''
};

export const initialParticipant: Participant = {
  fullName: '',
  email: '',
  phone: '',
  role: '',
};

export const initialFormData: ProjectFormData = {
  id: crypto.randomUUID(),
  programmeArea: 'Community Health Services',
  status: 'ongoing' as ProjectStatus, // Set to 'ongoing' for API compatibility
  projectTitle: '',
  problemStatement: '',
  problemStatementParts: { ...initialProblemStatementParts },
  department: '', // Explicitly initialize as empty string to avoid undefined
  projectCategory: '',
  firstCycleDate: '',
  projectEndDate: '',
  responsiblePerson: '',
  participants: [],
  chsTeamMembers: [], // Explicitly initialize as empty array
  potentialGaps: [], // Explicitly initialize as empty array
  decisionMatrix: [],
  rootCauses: [],
  indicatorDescription: '',
  useCustomIndicator: false,
  indicatorNumerator: '',
  indicatorDenominator: '',
  numeratorNumber: undefined,
  denominatorNumber: undefined,
  customKpiDefinition: '', // Explicitly initialize as empty string
  improvementFrom: 0,
  improvementTo: 100,
  problemIdentificationTool: 'decisionMatrix',
  rootCauseAnalysisTool: 'fishbone',
  measurementFrequency: 'MONTHLY',
  initiativeSource: 'CHS',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  // Initialize other commonly used fields to avoid 'possibly undefined' errors
  selectedKPI: '',
  domain: '',
  subDomain: '',
  // Initialize fishbone analysis with empty causeItems arrays
  fishBoneAnalysis: {
    peopleCauses: {
      causes: '',
      selectedCause: '',
      explanation: '',
      whyAnalysis: { why1: '', reason1: '', why2: '', reason2: '', why3: '', reason3: '', why4: '', reason4: '', why5: '', reason5: '', rootCause: '' },
      causeItems: []
    },
    processCauses: {
      causes: '',
      selectedCause: '',
      explanation: '',
      whyAnalysis: { why1: '', reason1: '', why2: '', reason2: '', why3: '', reason3: '', why4: '', reason4: '', why5: '', reason5: '', rootCause: '' },
      causeItems: []
    },
    policyCauses: {
      causes: '',
      selectedCause: '',
      explanation: '',
      whyAnalysis: { why1: '', reason1: '', why2: '', reason2: '', why3: '', reason3: '', why4: '', reason4: '', why5: '', reason5: '', rootCause: '' },
      causeItems: []
    },
    placeCauses: {
      causes: '',
      selectedCause: '',
      explanation: '',
      whyAnalysis: { why1: '', reason1: '', why2: '', reason2: '', why3: '', reason3: '', why4: '', reason4: '', why5: '', reason5: '', rootCause: '' },
      causeItems: []
    },
    provisionCauses: {
      causes: '',
      selectedCause: '',
      explanation: '',
      whyAnalysis: { why1: '', reason1: '', why2: '', reason2: '', why3: '', reason3: '', why4: '', reason4: '', why5: '', reason5: '', rootCause: '' },
      causeItems: []
    }
  }
};
